<template lang="pug">
span
  v-menu(v-model="show" rounded="lg" attach offset-y bottom max-height="345")
    template(#activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.rounded-lg(outlined height="28" v-bind="attrs" v-on="on")
        .text-xs.text-none.font-semibold Add dynamic filter
        v-icon.ml-2(size="16") $yzi-plus

    .text-xs.white
      .search-input
        v-text-field.my-2.mx-4.text-sm.round-xl(v-model="search" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      template(v-for="(item, idx) in filteredItems")
        div(:key="`${item.value}-${idx}`" @click="onSelectItem(item)")
          .d-flex.flex-column.py-3.px-4.hover-bg.clickable
            .text-sm {{ item.text }}
          v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: [],
  data: () => ({
    isLoading: false,
    isFetching: false,
    search: null,
    show: false,
    items: [
      { text: 'Birthday', id: 'birthday', filter: {} },
      { text: 'Age', id: 'dob__year', filter: {} },
      { text: 'Gender', id: 'gender', filter: {} },
      { text: 'Nationality', id: 'nationality', filter: {} },
      { text: 'Race', id: 'race', filter: {} },
      { text: 'Religion', id: 'religion', filter: {} },
      { text: 'Total visit', id: 'total_visit', filter: {} },
      { text: 'Medication', id: 'medication', filter: {} },
      { text: 'Service', id: 'service', filter: {} },
      { text: 'Last purchase', id: 'last_purchase', filter: {} },
      { text: 'Location (Postcode)', id: 'postcodes', filter: {} },
      { text: 'Purchase date', id: 'purchase_date', filter: {} },
      { text: 'Total spend (RM)', id: 'lifetime_value', filter: {} },
      { text: 'Membership joined date', id: 'joined_date', filter: {} },
      { text: 'Google reviews rating', id: 'google_review_star', filter: {} },
      { text: 'Reviews request status', id: 'review_invite_status', filter: {} },
      { text: 'Feedback rating', id: 'review_star', filter: {} },
    ]
  }),
  mounted () {},
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    filteredItems() {
      if (this.search) {
        const keyword = this.search.toLowerCase()
        return this.items.filter(item => (item.text.toLowerCase().includes(keyword)))
      }
      return this.items
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    onSelectItem (item) {
      this.$emit('added', item)
      this.show = false
    },
  }
}
</script>

<style scoped>
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>